<template>
  <div ref="rightSide" class="space-y-6">
    <div class="flex items-start justify-between gap-2.5">
      <h1 class="ui-h2 text-white">
        {{ productTitle }}
      </h1>
      <UiButton
        v-if="
          currentConfiguration?.data &&
          currentConfiguration.data.configuration_id
        "
        class="add-to-bag-section-icon flex-shrink-0 lg:inline-flex"
        variant="clear"
        variant-type="icon"
        size="xs"
        :aria-label="$t('addToWishlist')"
        @click="onUpdateWishlist"
      >
        <UiIcon
          name="bookmark"
          class="size-5 text-white"
          :class="[inWishlist ? 'fill-white text-white' : '']"
          aria-hidden="true"
        />
      </UiButton>
    </div>
    <div
      v-if="productDescription"
      class="!mt-2 ui-text-sm leading-6 text-white"
      v-html="productDescription"
    />
    <div
      class="flex items-center gap-1 cursor-pointer !mt-5"
      @click="productDetailsAndShippingDrawer = true"
    >
      <span class="ui-text-sm text-white underline">{{
        $t("productSpecsAndDetails")
      }}</span>
      <UiIcon name="arrow_right" class="size-4 text-white" aria-hidden="true" />
    </div>

    <div
      v-if="currentConfiguration?.data && isOutOfStock"
      class="ui-h4 text-xl lg:text-30_40 text-white"
    >
      {{ $t("outOfStock") }}
    </div>

    <div v-if="filtersPdpManyInOne" class="max-md:-mx-4 max-md:px-4">
      <div v-for="block in filteredMaterialsByCategories" :key="block?.id">
        <ProductMaterialFilter
          :result="result"
          :additional-options="additionalOptions"
          :block="block"
          is-regular-pdp
          @filter="onFilterClick"
          @options-filter="onOptionsFilterClick"
        />
      </div>
    </div>

    <section
      class="add-to-bag-section bg-black relative py-4"
      v-sticky="lgAndDown"
      sticky-side="bottom"
    >
      <div class="add-to-bag-btn">
        <UiButton
          class="w-full px-2 !text-white"
          color="white"
          size="lg"
          disabled
        >
          {{ $t("nowAvailableInRetailStoresOnly") }}
        </UiButton>
      </div>
    </section>
    <!--
    <section
      v-if="!isOutOfStock"
      class="add-to-bag-section bg-black relative py-4"
      v-sticky="lgAndDown"
      sticky-side="bottom"
    >
      <div class="add-to-bag-btn">
        <UiButton
          :loading="addToCartLoading"
          class="w-full px-2"
          color="white"
          size="lg"
          :disabled="addToCartLoading || hasUnavailableMaterial"
          @click="onAddToCart"
        >
          <span class="mr-1">{{ $t("addToCart") }} -</span>
          <span
            v-if="!isOutOfStock && productStartAtPrice"
            class="line-through mr-2"
          >
            {{ $n(productStartAtPrice, "currency") }}
          </span>
          <span>{{ $n(finalProductPrice, "currency") }}</span>
        </UiButton>
      </div>
      <SharedFieldHint
        v-if="hasUnavailableMaterial"
        class="mt-4"
        :message="$t('unavailableConfiguration')"
        error
      />
    </section>
    -->

    <!--
    <PagesProductDeliveryInfo
      :ship-date="currentConfiguration?.data?.ship_date"
    />
    -->

    <ProductDetailsAndShippingDrawer
      v-model="productDetailsAndShippingDrawer"
      :details-maped-data="detailsMapedData"
      :shipping-returns-accordion-data="shippingReturnsAccordionData"
    />
  </div>
</template>

<script setup lang="ts">
import { IProductPdpInfoProps, MaterialData } from "ecom-types";

const props = defineProps<IProductPdpInfoProps>();

const emit = defineEmits([
  "addToCart",
  "optionsFilter",
  "filter",
  "updateWishlist",
]);
const { lgAndDown } = useAppBreakpoints();

const productDetailsAndShippingDrawer = ref(false);

function onAddToCart() {
  if (props.hasUnavailableMaterial) return;
  emit("addToCart");
}

function onOptionsFilterClick(value: { slug: string; item?: MaterialData }) {
  emit("optionsFilter", value);
}

function onFilterClick(value: { slug: string; item?: MaterialData }) {
  emit("filter", value);
}

function onUpdateWishlist() {
  emit("updateWishlist");
}
</script>
